import { Card } from '../models/skyclub.interfaces';
import {
  NonUnlimitedMocks,
  UnlimitedCardMocks,
  UnlimitedMembershipMocks
} from './unlimited.mocks';
import {
  VisitsScaleHighMocks,
  VisitsScaleLowMocks,
  VisitsScaleZeroMocks
} from './visits.mocks';

export const SingleCard: Card[] = [
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleHighMocks,
    unlimited: NonUnlimitedMocks
  }
];
export const SingleCardNotice: Card[] = [
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleLowMocks,
    unlimited: NonUnlimitedMocks
  }
];
export const SingleCardZero: Card[] = [
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleZeroMocks,
    unlimited: NonUnlimitedMocks
  }
];

export const SingleCardUnlimitedCard: Card[] = [
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: '',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    unlimited: UnlimitedCardMocks
  }
];

export const SingleCardUnlimitedMembership: Card[] = [
  {
    name: 'Delta Sky Club Membership',
    description: '',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    unlimited: UnlimitedMembershipMocks
  }
];

export const MultiCards: Card[] = [
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleHighMocks,
    unlimited: NonUnlimitedMocks
  },
  {
    name: 'Delta SkyMiles® Reserve American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleLowMocks,
    unlimited: NonUnlimitedMocks
  }
];

export const MultiCardsUnlimitedCard: Card[] = [
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: '',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    unlimited: UnlimitedCardMocks
  },
  {
    name: 'Delta SkyMiles® Reserve American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleHighMocks,
    unlimited: NonUnlimitedMocks
  }
];

export const MultiCardsUnlimitedMembership: Card[] = [
  {
    name: 'Delta Sky Club Membership',
    description: '',
    unlimited: UnlimitedMembershipMocks
  },
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: '',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    unlimited: UnlimitedCardMocks
  },
  {
    name: 'Delta SkyMiles® Reserve American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    visits: VisitsScaleHighMocks,
    unlimited: NonUnlimitedMocks
  }
];

export const AllCardsUnlimitedMembership: Card[] = [
  {
    name: 'Delta Sky Club Membership',
    description: '',
    unlimited: UnlimitedMembershipMocks
  },
  {
    name: 'Delta SkyMiles® Reserve Business American Express Card',
    description: '',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    unlimited: UnlimitedCardMocks
  },
  {
    name: 'Delta SkyMiles® Reserve American Express Card',
    description: 'Seize the travel day. Unwind with us at a Delta Sky Club.',
    image: {
      src: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/skyclub-amex-reserve-card.svg',
      alt: 'Delta SkyMiles Reserve Card'
    },
    unlimited: UnlimitedCardMocks
  }
];

export const MultiCardCardMock: Card[] = [
  ...SingleCard,
  ...SingleCardNotice,
  ...SingleCardZero,
  ...SingleCardUnlimitedCard
];
